<template>
    <v-dialog
      v-model="dialog"
      width="700"
    >
      <template v-slot:activator="{ on }">
          <div v-on="on" style="cursor: pointer;" class="text-center py-5 ma-1 fill-height" :class="$vuetify.theme.dark == true?'darkModeCard':'whiteTheme'" >
               <v-avatar size="150">
                  <img 
                    :src="getImgPfad(cardData.img, 'projekte')"
        :lazy-src="getImgPfad(cardData.img, 'projekte')"
                  >
                </v-avatar>
                <p class="mt-3 mb-0 google-font mb-0" style="font-size:120%">{{cardData.name}}</p>
                <p class="mt-1 mb-0 google-font mt-0" style="font-size:80%">{{cardData.author}}</p>
            </div>
          
      </template>

      <v-card :class="theme.isDark?'grey darken-3':'white'">
        <v-card-title
          class="px-5 google-font"
          primary-title
        >
         {{cardData.name}} 
        </v-card-title>

        <v-card-text class="pa-5">
            <p class="google-font">{{cardData.beschreibung}}</p>
            <p class="google-font">{{cardData.author}}</p>
            
            <v-btn class="primary mt-3" small depressed @click="goTo(cardData.destination)">Zum Projekt</v-btn>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import {
    mapGetters
} from "vuex";
  export default {
    inject: ['theme'],
    props: {
      cardData: Object
    },
    data () {
      return {
        dialog: false,
      }
    },
    computed: {
        ...mapGetters(["currentUser"])
    },
    methods:{
      goTo(link){
        window.open(link+'/#/hash/'+this.currentUser.userHash+'/', '_blank')
      },
    }
  }
</script>

